import { apiRequest } from '@/core';
import { type DeleteEventMatchScoreEditPayload } from '@/slices/events/types';
import { type EventMatchScore } from '@/types';

export const deleteEventMatchScoreEditRequest = async ({
  eventId,
}: DeleteEventMatchScoreEditPayload) =>
  apiRequest<EventMatchScore>({
    endpoint: `api/events/${eventId}/match-score`,
    method: 'DELETE',
  });
